import { createFileRoute, redirect } from "@tanstack/react-router";

// Old-spelling alias for the organisation detail page; see ../index.tsx.
export const Route = createFileRoute(
  "/_authed/$companySlug/organizations/$organizationId/",
)({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/$companySlug/organisations/$organizationId",
      params,
      search,
      replace: true,
    });
  },
});
